export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  description: string;
  chapters: number;
  views: string;
  rating: number;
  isNew: boolean;
  isHot: boolean;
  status: '连载中' | '已完结';
  tags: string[];
  updatedAt: string;
}

export const featuredComics: Comic[] = [
  {
    id: 1,
    title: '暗夜追踪',
    author: '墨染青衣',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20romantic%20manga%20cover%20art%2C%20mysterious%20couple%20in%20moonlight%2C%20gothic%20atmosphere%2C%20dramatic%20shadows%2C%20elegant%20character%20design%2C%20warm%20amber%20and%20crimson%20color%20palette%2C%20japanese%20manga%20cover%20style%2C%20high%20contrast%2C%20clean%20simple%20background%20with%20soft%20gradients&width=800&height=1120&seq=comic-featured-01&orientation=portrait',
    category: '悬疑',
    description: '城市暗处隐藏着不为人知的秘密，一位私家侦探在追踪连环案件时，意外卷入了一场跨越十年的阴谋。',
    chapters: 128,
    views: '385.6万',
    rating: 9.6,
    isNew: false,
    isHot: true,
    status: '连载中',
    tags: ['悬疑', '都市', '推理'],
    updatedAt: '2026-08-10',
  },
  {
    id: 2,
    title: '星辰之约',
    author: '星野琉璃',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20fantasy%20manga%20cover%2C%20starry%20night%20sky%20background%2C%20beautiful%20couple%20embracing%2C%20ethereal%20glowing%20effects%2C%20soft%20romantic%20atmosphere%2C%20warm%20golden%20and%20pink%20tones%2C%20japanese%20shoujo%20manga%20style%2C%20clean%20elegant%20composition&width=800&height=1120&seq=comic-featured-02&orientation=portrait',
    category: '恋爱',
    description: '在星空下的约定，牵动着两个灵魂的命运。跨越时空的爱恋，能否在星辰的见证下圆满？',
    chapters: 96,
    views: '256.8万',
    rating: 9.4,
    isNew: false,
    isHot: true,
    status: '连载中',
    tags: ['恋爱', '奇幻', '治愈'],
    updatedAt: '2026-08-11',
  },
  {
    id: 3,
    title: '剑道至尊',
    author: '剑无名',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20martial%20arts%20manga%20cover%2C%20powerful%20swordsman%20silhouette%2C%20dramatic%20energy%20effects%2C%20ancient%20Chinese%20fantasy%20setting%2C%20warm%20crimson%20and%20gold%20color%20scheme%2C%20dynamic%20action%20pose%2C%20clean%20background%20with%20ink%20wash%20texture%2C%20japanese%20manga%20style&width=800&height=1120&seq=comic-featured-03&orientation=portrait',
    category: '玄幻',
    description: '少年剑客机缘巧合下获得上古剑诀，从此踏上了逆天改命的修炼之路，一剑破万法，傲视九重天。',
    chapters: 256,
    views: '682.3万',
    rating: 9.7,
    isNew: false,
    isHot: true,
    status: '连载中',
    tags: ['玄幻', '热血', '战斗'],
    updatedAt: '2026-08-11',
  },
  {
    id: 4,
    title: '总裁的契约恋人',
    author: '冰糖雪梨',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20romance%20manga%20cover%2C%20handsome%20businessman%20and%20beautiful%20woman%2C%20luxury%20city%20backdrop%2C%20sophisticated%20fashion%2C%20warm%20romantic%20lighting%2C%20soft%20rose%20and%20gold%20tones%2C%20japanese%20josei%20manga%20style%2C%20clean%20composition&width=800&height=1120&seq=comic-featured-04&orientation=portrait',
    category: '都市',
    description: '一场契约婚姻，让普通女孩闯入了冷面总裁的世界。当假戏真做，爱情悄然降临...',
    chapters: 180,
    views: '521.4万',
    rating: 9.3,
    isNew: false,
    isHot: true,
    status: '连载中',
    tags: ['都市', '恋爱', '总裁'],
    updatedAt: '2026-08-10',
  },
];

export const newComics: Comic[] = [
  {
    id: 5,
    title: '异世界美食之旅',
    author: '味蕾漫游',
    cover: 'https://readdy.ai/api/search-image?query=Whimsical%20fantasy%20food%20manga%20cover%2C%20cheerful%20chef%20character%20in%20magical%20kitchen%2C%20colorful%20dishes%20floating%2C%20warm%20inviting%20atmosphere%2C%20soft%20golden%20lighting%2C%20japanese%20manga%20art%20style%2C%20clean%20background%2C%20appetizing%20food%20illustration&width=800&height=1120&seq=comic-new-01&orientation=portrait',
    category: '玄幻',
    description: '普通厨师穿越到美食至上的异世界，用现代厨艺征服异界味蕾！',
    chapters: 45,
    views: '12.8万',
    rating: 9.1,
    isNew: true,
    isHot: false,
    status: '连载中',
    tags: ['玄幻', '美食', '搞笑'],
    updatedAt: '2026-08-11',
  },
  {
    id: 6,
    title: '夜行御史',
    author: '墨白',
    cover: 'https://readdy.ai/api/search-image?query=Historical%20fantasy%20manga%20cover%2C%20mysterious%20official%20in%20ancient%20Chinese%20robe%2C%20night%20scene%20with%20lanterns%2C%20dark%20mysterious%20atmosphere%2C%20warm%20amber%20lighting%20contrasts%2C%20japanese%20seinen%20manga%20style%2C%20clean%20dramatic%20composition&width=800&height=1120&seq=comic-new-02&orientation=portrait',
    category: '悬疑',
    description: '古代王朝暗流涌动，夜行御史暗中查案，揭开惊天秘密。',
    chapters: 32,
    views: '8.5万',
    rating: 9.2,
    isNew: true,
    isHot: false,
    status: '连载中',
    tags: ['悬疑', '古装', '探案'],
    updatedAt: '2026-08-11',
  },
  {
    id: 7,
    title: '机甲狂潮',
    author: '铁甲小宝',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20mecha%20manga%20cover%2C%20giant%20robot%20in%20action%20pose%2C%20sci-fi%20city%20background%2C%20dramatic%20energy%20beams%2C%20metallic%20warm%20tones%20with%20neon%20accents%2C%20japanese%20mecha%20manga%20style%2C%20dynamic%20composition%2C%20clean%20background&width=800&height=1120&seq=comic-new-03&orientation=portrait',
    category: '科幻',
    description: '未来世界，人类与机甲共生。少年驾驶神秘机甲，保卫人类最后的希望。',
    chapters: 28,
    views: '6.2万',
    rating: 9.0,
    isNew: true,
    isHot: false,
    status: '连载中',
    tags: ['科幻', '机甲', '热血'],
    updatedAt: '2026-08-10',
  },
  {
    id: 8,
    title: '花间集',
    author: '画棠',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20historical%20romance%20manga%20cover%2C%20beautiful%20woman%20in%20traditional%20Chinese%20dress%20among%20blossoms%2C%20soft%20pastel%20colors%2C%20romantic%20spring%20atmosphere%2C%20delicate%20flower%20petals%2C%20japanese%20shoujo%20manga%20style%2C%20clean%20graceful%20composition&width=800&height=1120&seq=comic-new-04&orientation=portrait',
    category: '古装',
    description: '花间一壶酒，独酌无相亲。名门闺秀与江湖侠客的唯美邂逅。',
    chapters: 56,
    views: '18.3万',
    rating: 9.3,
    isNew: true,
    isHot: false,
    status: '连载中',
    tags: ['古装', '恋爱', '唯美'],
    updatedAt: '2026-08-09',
  },
  {
    id: 9,
    title: '深海迷踪',
    author: '深海蓝鲸',
    cover: 'https://readdy.ai/api/search-image?query=Mysterious%20underwater%20fantasy%20manga%20cover%2C%20diver%20exploring%20ancient%20ruins%20under%20sea%2C%20bioluminescent%20creatures%2C%20deep%20blue%20and%20teal%20atmosphere%20with%20warm%20light%20rays%2C%20adventure%20manga%20style%2C%20clean%20composition&width=800&height=1120&seq=comic-new-05&orientation=portrait',
    category: '科幻',
    description: '深海之下隐藏着失落的文明，探险队在万米海底发现惊天秘密。',
    chapters: 22,
    views: '5.1万',
    rating: 8.9,
    isNew: true,
    isHot: false,
    status: '连载中',
    tags: ['科幻', '冒险', '悬疑'],
    updatedAt: '2026-08-08',
  },
];

export const hotComics: Comic[] = [
  {
    id: 10,
    title: '绝世神医',
    author: '妙手回春',
    cover: 'https://readdy.ai/api/search-image?query=Medical%20fantasy%20manga%20cover%2C%20skilled%20doctor%20character%20with%20mystical%20energy%2C%20ancient%20Chinese%20medicine%20elements%2C%20dramatic%20healing%20effects%2C%20warm%20emerald%20and%20gold%20tones%2C%20japanese%20manga%20style%2C%20clean%20composition&width=800&height=1120&seq=comic-hot-01&orientation=portrait',
    category: '玄幻',
    description: '现代医学天才穿越古代，凭借超凡医术逆天改命，成为一代绝世神医。',
    chapters: 312,
    views: '892.6万',
    rating: 9.8,
    isNew: false,
    isHot: true,
    status: '连载中',
    tags: ['玄幻', '医学', '逆袭'],
    updatedAt: '2026-08-11',
  },
  {
    id: 11,
    title: '霸道王爷轻点宠',
    author: '月下独酌',
    cover: 'https://readdy.ai/api/search-image?query=Historical%20romance%20manga%20cover%2C%20handsome%20prince%20and%20elegant%20woman%20in%20ancient%20palace%2C%20luxurious%20silk%20robes%2C%20warm%20candlelight%20atmosphere%2C%20romantic%20tension%2C%20japanese%20shoujo%20manga%20style%2C%20clean%20elegant%20composition&width=800&height=1120&seq=comic-hot-02&orientation=portrait',
    category: '古装',
    description: '穿越成为不受宠的王妃，且看她如何步步为营，让霸道王爷为她倾心。',
    chapters: 245,
    views: '756.3万',
    rating: 9.5,
    isNew: false,
    isHot: true,
    status: '连载中',
    tags: ['古装', '恋爱', '宫斗'],
    updatedAt: '2026-08-11',
  },
  {
    id: 12,
    title: '末世求生指南',
    author: '末日行者',
    cover: 'https://readdy.ai/api/search-image?query=Post-apocalyptic%20survival%20manga%20cover%2C%20survivor%20with%20weapon%20in%20ruined%20city%2C%20dramatic%20orange%20sky%2C%20gritty%20atmosphere%2C%20warm%20dusty%20tones%2C%20action%20manga%20style%2C%20tense%20composition%2C%20clean%20background&width=800&height=1120&seq=comic-hot-03&orientation=portrait',
    category: '科幻',
    description: '末日降临，丧尸横行。普通人如何在末世中求生，守护最后的希望？',
    chapters: 198,
    views: '623.5万',
    rating: 9.6,
    isNew: false,
    isHot: true,
    status: '连载中',
    tags: ['科幻', '末世', '生存'],
    updatedAt: '2026-08-10',
  },
  {
    id: 13,
    title: '我的合租女友',
    author: '城市夜归人',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20slice%20of%20life%20manga%20cover%2C%20young%20couple%20in%20cozy%20apartment%2C%20warm%20interior%20lighting%2C%20casual%20everyday%20scene%2C%20soft%20comfortable%20atmosphere%2C%20japanese%20seinen%20manga%20style%2C%20clean%20composition&width=800&height=1120&seq=comic-hot-04&orientation=portrait',
    category: '都市',
    description: '与陌生女孩合租的日子，从尴尬到心动，都市青年的甜蜜日常。',
    chapters: 156,
    views: '489.2万',
    rating: 9.4,
    isNew: false,
    isHot: true,
    status: '连载中',
    tags: ['都市', '恋爱', '日常'],
    updatedAt: '2026-08-09',
  },
  {
    id: 14,
    title: '狐妖之契约',
    author: '妖言惑众',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20supernatural%20manga%20cover%2C%20beautiful%20fox%20spirit%20woman%20with%20magical%20aura%2C%20mystical%20forest%20background%2C%20ethereal%20glowing%20effects%2C%20warm%20amber%20and%20crimson%20tones%2C%20japanese%20manga%20style%2C%20clean%20composition&width=800&height=1120&seq=comic-hot-05&orientation=portrait',
    category: '玄幻',
    description: '千年狐妖与人类少年签订契约，一段跨越种族的奇幻冒险就此展开。',
    chapters: 178,
    views: '534.1万',
    rating: 9.5,
    isNew: false,
    isHot: true,
    status: '连载中',
    tags: ['玄幻', '妖怪', '冒险'],
    updatedAt: '2026-08-08',
  },
  {
    id: 15,
    title: '暗恋手册',
    author: '心动日记',
    cover: 'https://readdy.ai/api/search-image?query=Sweet%20high%20school%20romance%20manga%20cover%2C%20shy%20couple%20under%20cherry%20blossoms%2C%20spring%20atmosphere%2C%20soft%20pink%20and%20warm%20tones%2C%20youthful%20innocent%20feeling%2C%20japanese%20shoujo%20manga%20style%2C%20clean%20composition&width=800&height=1120&seq=comic-hot-06&orientation=portrait',
    category: '恋爱',
    description: '高中时代最纯粹的心动，一本暗恋手册记录着青春最美好的秘密。',
    chapters: 88,
    views: '367.8万',
    rating: 9.3,
    isNew: false,
    isHot: true,
    status: '已完结',
    tags: ['恋爱', '校园', '青春'],
    updatedAt: '2026-07-15',
  },
];

export const completedComics: Comic[] = [
  {
    id: 16,
    title: '江湖风云录',
    author: '风云无忌',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20wuxia%20manga%20cover%2C%20warrior%20standing%20on%20mountain%20peak%2C%20dramatic%20sunset%20sky%2C%20flowing%20robes%20in%20wind%2C%20chinese%20ink%20wash%20style%2C%20warm%20golden%20and%20crimson%20tones%2C%20heroic%20atmosphere%2C%20clean%20composition&width=800&height=1120&seq=comic-completed-01&orientation=portrait',
    category: '玄幻',
    description: '江湖恩怨，儿女情长。一代大侠的传奇人生，荡气回肠的武侠史诗。',
    chapters: 420,
    views: '1256.3万',
    rating: 9.9,
    isNew: false,
    isHot: true,
    status: '已完结',
    tags: ['玄幻', '武侠', '史诗'],
    updatedAt: '2026-06-20',
  },
  {
    id: 17,
    title: '倾城之恋',
    author: '月上柳梢',
    cover: 'https://readdy.ai/api/search-image?query=Tragic%20romance%20manga%20cover%2C%20separated%20lovers%20in%20rain%2C%20nostalgic%20melancholic%20atmosphere%2C%20soft%20muted%20warm%20tones%2C%20umbrella%20and%20falling%20petals%2C%20japanese%20josei%20manga%20style%2C%20clean%20emotional%20composition&width=800&height=1120&seq=comic-completed-02&orientation=portrait',
    category: '恋爱',
    description: '一段跨越十年的爱恋，倾城之恋，倾尽一生。感人至深的爱情故事。',
    chapters: 200,
    views: '892.1万',
    rating: 9.7,
    isNew: false,
    isHot: true,
    status: '已完结',
    tags: ['恋爱', '虐心', '经典'],
    updatedAt: '2026-05-30',
  },
  {
    id: 18,
    title: '科技帝国',
    author: '数字游民',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20tech%20thriller%20manga%20cover%2C%20hacker%20in%20digital%20world%2C%20cyberspace%20visualization%2C%20neon%20warm%20accents%20on%20dark%20background%2C%20sleek%20modern%20aesthetic%2C%20japanese%20seinen%20manga%20style%2C%20clean%20composition&width=800&height=1120&seq=comic-completed-03&orientation=portrait',
    category: '科幻',
    description: '一个程序员的白手起家之路，从车库到科技帝国的传奇创业故事。',
    chapters: 180,
    views: '445.6万',
    rating: 9.2,
    isNew: false,
    isHot: false,
    status: '已完结',
    tags: ['科幻', '创业', '商战'],
    updatedAt: '2026-04-15',
  },
  {
    id: 19,
    title: '青楼梦',
    author: '红袖添香',
    cover: 'https://readdy.ai/api/search-image?query=Historical%20drama%20manga%20cover%2C%20elegant%20courtesan%20in%20ancient%20Chinese%20setting%2C%20ornate%20traditional%20costume%2C%20warm%20lantern%20light%2C%20nostalgic%20atmosphere%2C%20japanese%20historical%20manga%20style%2C%20clean%20graceful%20composition&width=800&height=1120&seq=comic-completed-04&orientation=portrait',
    category: '古装',
    description: '乱世之中，青楼女子的人生百态。红尘滚滚，谁人能懂女儿心？',
    chapters: 160,
    views: '378.2万',
    rating: 9.4,
    isNew: false,
    isHot: false,
    status: '已完结',
    tags: ['古装', '女性', '历史'],
    updatedAt: '2026-03-28',
  },
];

export const allComics: Comic[] = [
  ...featuredComics,
  ...newComics,
  ...hotComics,
  ...completedComics,
];